import InterfaceSwitcher from './interfaceSwitcher';
export default InterfaceSwitcher;